<bwh-lib-step-control-bar
  [langDropdown]="true"
  [prevBut]="prevBut"
  [closeBut]="closeBut"
  [currentStep]="wizardService?.currentStep"
  [previousStep]="wizardService?.previousStep"
  [steps]="wizardService?.totalSteps"
  (emitClose)="close()"
  (emitPrev)="goPrev()"
></bwh-lib-step-control-bar>
<div class="text-center step-wrapper">
  <div class="main-header">
    <h1 class="main-title">{{ 'global.search_and_add_skills' | translate }}</h1>
  </div>
  <div class="scrollable-content">
    <p class="main-description">{{ 'global.search_add_skills_description' | translate }}</p>

    <form *ngIf="dataLoaded" [formGroup]="form">
      <!-- Added skills list -->
      <mat-chip-list class="added-skills-section" *ngIf="addedSkills.length > 0">
        <mat-chip
          *ngFor="let skill of addedSkills.controls; let i = index"
          [removable]="true"
          (removed)="toggleSkillActive(i)"
        >
          {{ skill.value.skill_name }}
          <span matChipRemove>&#x2715;</span>
        </mat-chip>
      </mat-chip-list>

      <div class="tabs-header-wrapper">
        <span class="section-origin-tag" *ngIf="sectionTitle">{{ sectionTitle }}</span>
      </div>
      <mat-tab-group class="skills-tabs" [class.has-section-tag]="sectionTitle" [(selectedIndex)]="selectedTabIndex" dynamicHeight>
        <!-- Tab 1: Skills by profession -->
        <mat-tab [label]="'global.professions' | translate">
          <div class="tab-content">
            <div class="profession-search-section" *ngIf="!selectedProfession">
              <mat-chip-list class="my-professions-tags" *ngIf="myProfessionTags.length > 0">
                <mat-chip
                  *ngFor="let tag of myProfessionTags"
                  (click)="handleMyProfessionTagClick(tag)"
                >
                  {{ tag.text }}
                </mat-chip>
              </mat-chip-list>
              <lib-single-select-search
                #professionSearchAutocomplete
                [options]="professionOptions"
                [placeholder]="'global.search_profession' | translate"
                [iconPath]="'/icons/search-icon.svg'"
                [staticIcon]="true"
                [myFloatLabel]="'never'"
                [addDebounce]="300"
                [clearInput]="true"
                [waitForOptionsChange]="true"
                [suggestionsOff]="true"
                (changed)="handleProfessionSelected($event)"
                (valueChanged)="handleProfessionSearchValueChanged($event)"
              >
              </lib-single-select-search>
            </div>

            <div class="selected-profession-section" *ngIf="selectedProfession">
              <div class="selected-profession-header">
                <span class="selected-profession-name">{{ selectedProfession.text }}</span>
                <button class="btn-change-profession" type="button" (click)="clearSelectedProfession()">
                  {{ 'global.change' | translate }}
                </button>
              </div>

              <div class="profession-skills-checkboxes" *ngIf="professionSkillsLoaded">
                <ng-container *ngFor="let skill of professionSkills">
                  <div
                    *ngIf="!isSkillAdded(skill)"
                    class="skill-checkbox-tile"
                    (click)="toggleProfessionSkill(skill)"
                    [class.selected]="isSkillAdded(skill)"
                  >
                    <mat-checkbox
                      (change)="toggleProfessionSkill(skill)"
                      (click)="$event.stopPropagation()"
                      color="primary"
                    >
                      {{ skill.text }}
                    </mat-checkbox>
                  </div>
                </ng-container>
                <p *ngIf="professionSkills.length === 0" class="no-skills-message">
                  {{ 'global.no_profession_skills_available' | translate }}
                </p>
              </div>
              <div class="loading-spinner" *ngIf="!professionSkillsLoaded">
                <mat-spinner [diameter]="30"></mat-spinner>
              </div>
            </div>
          </div>
        </mat-tab>

        <!-- Tab 2: Custom skill search -->
        <mat-tab [label]="'global.custom_skills' | translate">
          <div class="tab-content">
            <div class="search-container">
              <lib-single-select-search
                #searchAutocomplete
                [options]="filteredSearchSkills"
                [placeholder]="'global.type_skill_and_press_enter' | translate"
                [iconPath]="'/icons/search-icon.svg'"
                [staticIcon]="true"
                [myFloatLabel]="'never'"
                [addDebounce]="300"
                [clearInput]="true"
                [waitForOptionsChange]="true"
                [suggestionsOff]="true"
                [detectScrollToEnd]="true"
                (changed)="handleSearchSkillClick($event)"
                (valueChanged)="handleSearchValueChanged($event)"
                (scrolledToEnd)="handleScrolledToEnd()"
              >
              </lib-single-select-search>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>

      <ul class="next-button-container">
        <li *ngIf="prevBut === true && disableNext">
          <button class="btn w-md h-lg primary" type="button" [disabled]="saving" (click)="onCancel()">
            {{ 'global.cancel' | translate }}
          </button>
        </li>
        <li *ngIf="prevBut === true">
          <button class="btn w-md h-lg secondary prev-btn" type="button" [disabled]="saving" (click)="goPrev()">
            {{ 'global.done' | translate }}
          </button>
        </li>
        <li *ngIf="!disableNext">
          <button *ngIf="!editing" class="btn w-md h-lg secondary" type="button" [disabled]="saving" (click)="onSubmit()">
            {{ 'global.next_button' | translate }}
          </button>
          <button *ngIf="editing" class="btn w-md h-lg secondary" type="button" [disabled]="saving" (click)="onEdit()">
            {{ 'global.done' | translate }}
          </button>
        </li>
      </ul>
    </form>
  </div>
</div>
